import React from "react";

import "../../utilities.css";
import "./EventStatus.css";

/**
 * Eventstatus is a component that displays the status of individual WCR events.
 *
 * Proptypes
 * @param {string} startDate
 * @param {string} endDate
 * @param {string} status
 * @param {Object} statusToColor
 */

const EventStatus = ({startDate, endDate, status, statusToColor}) => {
  const currentTime = new Date()
  let eventStatus;

  if (status === "Confirmed") {
    if (endDate) {
      if (currentTime < new Date(endDate) && new Date(startDate) <= currentTime) {
        eventStatus = "Happening Now"
      } else {
        eventStatus = "Confirmed"
      }
    } else {
      if (new Date(currentTime.getTime() - 60*60000) < new Date(startDate) && new Date(startDate) <= currentTime) {
        eventStatus = "Happening Now"
      } else {
        eventStatus = "Confirmed"
      }
    }
  } else {
    eventStatus = status || "To be confirmed";
  }

  let finalBkgColor = "#000";
  if (statusToColor[eventStatus]) {finalBkgColor = statusToColor[eventStatus].bkgColor}

  return (
    <>
      { eventStatus !== "Confirmed" && <div style={{
        padding: ".25rem",
        textAlign: "center",
        marginBottom: ".5rem",
        backgroundColor: finalBkgColor,
        borderRadius: ".5rem",
        color: "#FFF"
      }}>
        {eventStatus}
      </div>}
    </>
  )
}

export default EventStatus;